import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { config } from '../common/constant';

const poolData = {
    UserPoolId: config.AWS_COGNITO_LOGIN_POOL.USER_POOL_ID,
    ClientId: config.AWS_COGNITO_LOGIN_POOL.CLIENT_ID,   
}

export default new CognitoUserPool(poolData);
